import { Routes } from 'constants/routeConstants';
import { RETURN_URL_STORAGE_KEY } from 'modules/auth/constants';
import { REQUIRED_VERIFICATION_MODAL, SIGN_IN_STATUS } from 'modules/auth/pages/SignIn/constants';
import { redirectToDashboard } from 'modules/auth/pages/SignIn/sagas';
import { call, put, select } from 'redux-saga/effects';
import { matchPath } from 'react-router-dom';
import { replace, push } from 'modules/reduxNavigation/actions';
import { openModal } from 'components/TP-UI/TPModal/actions';
import { get } from 'lodash';
import { getIsClientRole, getUser } from 'modules/auth/selectors';

function* redirectUser(action) {
  const user = yield select(getUser);
  const isClient = yield select(getIsClientRole);
  if (!isClient || user.mfa?.enabled || user.mfa?.postponed) {
    yield call(redirectToDashboard, action);
  } else {
    yield put(replace(Routes.AUTH_MFA_SETUP));
  }
}

export function* handleSignInStatus({ action, successCallback }) {
  const status = get(action, 'response.data.status');
  let returnUrlInfo = sessionStorage.getItem(RETURN_URL_STORAGE_KEY);
  returnUrlInfo = returnUrlInfo ? JSON.parse(returnUrlInfo) : null;

  if (status === SIGN_IN_STATUS.NEED_MFA) {
    yield put(push(Routes.AUTH_MFA_INPUT));
  } else if (status === SIGN_IN_STATUS.PASSWORD_CHANGE_REQUIRED) {
    yield put(push(Routes.AUTH_FORCE_PASSWORD_CHANGE));
  } else if (status === SIGN_IN_STATUS.REQUIRED_VERIFICATION) {
    if (returnUrlInfo && matchPath(returnUrlInfo?.pathname, Routes.AUTH_EMAIL_VERIFICATION)) {
      sessionStorage.removeItem(RETURN_URL_STORAGE_KEY);
      yield put(push(returnUrlInfo));
    } else {
      yield put(openModal(REQUIRED_VERIFICATION_MODAL));
    }
  } else if (status === SIGN_IN_STATUS.REQUIRED_PHONE_VERIFICATION) {
    yield put(push(Routes.AUTH_PHONE_VERIFICATION));
  } else if (status === SIGN_IN_STATUS.SETUP_MFA) {
    yield put(push(Routes.AUTH_MFA_SETUP));
  } else {
    if (successCallback) {
      yield call(successCallback, action);
    } else {
      yield call(redirectUser, action);
    }
  }
}
